<div *ngIf="isCustomAccess && (customCondition == undefined || customCondition == '')">
  <app-wizard-filter-section
    [sectionId]="this.moduleStructure.module.AdditionalInformationParsed.CustomConditionSectionId"
    [(filterFields)]="filterFields" (okButtonClicked)="customConditionOkButtonClicked()" [showCancelButton]="false"
    [okButtonLabel]="'Start'" [filterFooterVisible]="true" [embdedSection]="true">
  </app-wizard-filter-section>
</div>
<div *ngIf="!isCustomAccess || (isCustomAccess && customCondition !== undefined && customCondition !== '')">
  <nz-result *ngIf="isError === true" [nzStatus]="'warning'" [nzTitle]="this.errorMessage">
  </nz-result>

  <nz-skeleton *ngIf="isLoading !== false" nzActive="true" style="padding: 35px">
  </nz-skeleton>
  <div style="
    display: flex;
    flex-direction: column;
    align-items: stretch;
    height: 100%;
  " class="records-list" *ngIf="isLoading == false && !isError">
    <ng-template #backButton>
      <i nz-icon nzType="arrow-left" nzTheme="outline" *ngIf="this.displayBackIcon"></i>
    </ng-template>
    <ng-template #pageTitleTemplate>
      <i [class]="'far fa-' + icon"></i>
      <span>
        {{
        pageTitle === null || pageTitle === "" || pageTitle === undefined
        ? isKanban
        ? ""
        : (moduleInformation.ListOfText | locale) +
        (fromDraft ? " (Drafts)" : "") + (customTitleSuffix !== '' ? ' (' + customTitleSuffix + ')' : '')
        : (pageTitle | locale) + (customTitleSuffix !== '' ? ' (' + customTitleSuffix + ')' : '')
        }}
      </span>
    </ng-template>
    <nz-page-header *ngIf="displayHeader" [nzBackIcon]="this.displayBackIcon ? backButton : null"
      [nzTitle]="pageTitleTemplate" [nzSubtitle]="pageSubtitle" (nzBack)="pageHaderBack()">
      <nz-page-header-extra>
        <nz-button-group>
          <button nz-button nzType="primary" *ngIf="
            this.moduleStructure != undefined &&
            this.moduleInformation.AuthorisedForCreate &&
            displayNewButton &&
            !fromDraft
          " (click)="openNewRecDrawer()">
            <i nz-icon nzType="plus" nzTheme="outline"></i>
            <span *ngIf="
              displayLabels &&
              !isKanban &&
              !(screenSize === 'small' || screenSize === 'x-small')
            ">{{ "Create" | locale }}</span>
          </button>
          <button nz-button nzType="primary" style="margin-right: 10px; margin-left: 10px;" *ngIf="inDrawer" (click)="
            choose()
          " [disabled]="this.selectedRecords.length === 0">
            <i nz-icon nzType="check-circle" nzTheme="outline"></i>
            {{ "Choose" | locale }}
          </button>
          <button nz-button nzType="default" *ngIf="
            this.moduleStructure != undefined &&
            this.moduleInformation.AuthorisedForCreate &&
            displaySearchButton
          " (click)="searchVisible = !searchVisible">
            <i nz-icon nzType="search" nzTheme="outline"></i>
            <span *ngIf="
              displayLabels &&
              !isKanban &&
              !(screenSize === 'small' || screenSize === 'x-small')
            ">{{ "Search" | locale }}</span>
          </button>
          <button *ngIf="isCustomAccess" nz-button nzType="default" (click)="resetCustomCondition()">
            {{this.moduleStructure.module.AdditionalInformationParsed.ClearCustomConditionButtonLabel | locale}}
          </button>
          <button nz-button (click)="showDrafts()" *ngIf="showDraftButton">
            <i class="fal fa-file-alt"></i>
            <span *ngIf="
              !(
                !displayLabels ||
                isKanban ||
                screenSize === 'medium' ||
                screenSize === 'small' ||
                screenSize === 'x-small'
              )
            ">{{
              fromDraft ? ("Documents" | locale) : ("Drafts" | locale)
              }}</span>
          </button>
          <button nz-button (click)="exportTheRecords('excel')" [nzLoading]="exporting" *ngIf="allowExportToExcel">
            <i class="fal fa-excel"></i>
            <span *ngIf="
              !(
                !displayLabels ||
                isKanban ||
                screenSize === 'medium' ||
                screenSize === 'small' ||
                screenSize === 'x-small'
              )
            ">{{
              ("Export" | locale)
              }}</span>
          </button>
          <button
          nz-button
          *ngIf="allowBulkEdit"
          [disabled]="selectedItemsForBulkEdit.length===0"
          (click)="open()">
            Bulk Edit
          </button>
          <button nz-button (click)="reloadTheRecords()">
            <i nz-icon nzType="reload" nzTheme="outline"></i>
            <span *ngIf="
              !(
                !displayLabels ||
                isKanban ||
                screenSize === 'medium' ||
                screenSize === 'small' ||
                screenSize === 'x-small'
              )
            ">{{ "Refresh" | locale }}</span>
          </button>

          <button nz-button (click)="reloadTheRecords(false,true)">
            <span nz-icon nzType="clear" nzTheme="outline"></span>
            <span *ngIf="
              !(
                !displayLabels ||
                isKanban ||
                screenSize === 'medium' ||
                screenSize === 'small' ||
                screenSize === 'x-small'
              )
            ">{{ "Reset Filters" | locale }}</span>
          </button>

          <button nz-button nz-dropdown [nzDropdownMenu]="sortingDM" #sortingButton="nzButton"
            *ngIf="this.fields !== undefined">
            <i nz-icon [nzType]="
              sortedByDir === 'ASC' ? 'sort-ascending' : 'sort-descending'
            " nzTheme="outline"></i>
            <span *ngIf="
              !(
                !displayLabels ||
                isKanban ||
                screenSize === 'medium' ||
                screenSize === 'small' ||
                screenSize === 'x-small'
              )
            ">{{ this.sortedByName | locale }}</span>
          </button>
          <button *ngIf="
            displayLabels &&
            !global.hideDisplayModeDropdown &&
            !isKanban &&
            !(
              screenSize === 'medium' ||
              screenSize === 'small' ||
              screenSize === 'x-small'
            )
          " nz-button nz-dropdown [nzDropdownMenu]="displayModeDM">
            <i nz-icon [nzType]="displayMode === 'cards' ? 'appstore' : 'table'" nzTheme="outline"></i>
          </button>

          <button nz-button nz-dropdown (click)="showFilterDrawer = true" #sortingButton="nzButton" *ngIf="this.fields !== undefined && (displayMode === 'cards' || screenSize === 'medium' ||
            screenSize === 'small' ||
            screenSize === 'x-small')">
            <i nz-icon nzType="filter" nzTheme="outline"></i>
          </button>

          <nz-dropdown-menu #sortingDM="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="changeSortingMode(i + 1)"
                *ngFor="let field of this.sortablFields; let i = index">
                <i nz-icon [nzType]="
                  sortedByDir === 'ASC' ? 'sort-ascending' : 'sort-descending'
                " *ngIf="this.sortedByField - 1 === i"></i>
                <i nz-icon [nzType]="'minus'" *ngIf="this.sortedByField - 1 !== i"></i>
                {{ field.Label | locale }}
              </li>
            </ul>
          </nz-dropdown-menu>

          <nz-dropdown-menu #displayModeDM="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="changeDisplayMode('cards')">
                <i nz-icon nzType="appstore"></i>
                {{ "Display Cards" | locale }}
              </li>
              <li nz-menu-item (click)="changeDisplayMode('table')">
                <i nz-icon nzType="table" nzTheme="outline"></i>
                {{ "Display Table" | locale }}
              </li>
            </ul>
          </nz-dropdown-menu>
        </nz-button-group>
      </nz-page-header-extra>
      <nz-page-header-content *ngIf="searchVisible">
        <nz-input-group [nzSuffix]="suffixIconSearch" nzSize="large" nzSearch="true">
          <input #searchField type="text" nz-input [(ngModel)]="term" (change)="reloadTheRecords()"
            [placeholder]="'Search' | locale" />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <i nz-icon nzType="search"></i>
          <i nz-icon nzType="close" style="padding-left: 15px;" (click)="term='';reloadTheRecords()"></i>
        </ng-template>
      </nz-page-header-content>
      <nz-page-header-content style="font-size: medium"
        *ngIf="moduleStructure.module.AdditionalInformationParsed.ListHintMessage !== ''">
        {{moduleStructure.module.AdditionalInformationParsed.ListHintMessage}}
      </nz-page-header-content>
    </nz-page-header>
    <div class="records-list-body">
      <app-records-list-cards (reloadRecords)="reloadTheRecords()" [isEditable]="isEditable"
        [listOfRecords]="listOfRecords" [isLoading]="isLoadingData" [pageSize]="pageSize"
        [moduleStructure]="moduleStructure" [selectedRecords]="selectedRecords"
        [selectedRecordsFromCheckBox]="selectedRecordsFromCheckBox" (selectRecord)="selectRecord($event)"
        (selectRecordFromCheckBox)="selectRecordFromCheckBox($event)" *ngIf="
        isKanban ||
        (moduleStructure.module.AdditionalInformationParsed.ListTemplate !=
          null &&
          !isKanban &&
          (displayMode === 'cards' ||
            screenSize === 'medium' ||
            screenSize === 'small' ||
            screenSize === 'x-small'))
      " [customActions]="customActions" (customActionClicked)="customActionClicked.emit($event)" [isKanban]="isKanban"
        [keyName]="keyName" [moduleActions]="moduleActions" [moduleInformation]="moduleInformation"
        [inModuleList]="inModuleList" [fromDraft]="fromDraft" [showCheckBoxInTableMode]="showCheckBoxInTableMode"
        [class]="'module-list-cards-' + moduleStructure.module.Id">
      </app-records-list-cards>

      <app-records-list-table  (submitClicked)="handleSubmitFromTable()" (selectedItemsChange)="onSelectedItemsChange($event)"
        [listOfRecords]="listOfRecords" [(sortedByField)]="sortedByField" [(sortedByDir)]="sortedByDir"
        (sortChanged)="reloadTheRecords()" [isLoading]="isLoadingData" [pageSize]="pageSize"
        [moduleStructure]="moduleStructure" [selectedRecords]="selectedRecords"
        [selectedRecordsFromCheckBox]="selectedRecordsFromCheckBox" (selectRecord)="selectRecord($event)"
        (selectRecordFromCheckBox)="selectRecordFromCheckBox($event)" [customActions]="customActions"
        [showCheckBoxInTableMode]="showCheckBoxInTableMode" (customActionClicked)="customActionClicked.emit($event)"
        [fields]="fields" [(filters)]="filters" [keyName]="keyName" [moduleActions]="moduleActions"
        [moduleInformation]="moduleInformation" [inModuleList]="inModuleList" [fromDraft]="fromDraft"
        [class]="'module-list-table-' + moduleStructure.module.Id" *ngIf="
        !isKanban &&
        (moduleStructure.module.AdditionalInformationParsed.ListTemplate ==
          null ||
          !(
            displayMode === 'cards' ||
            screenSize === 'medium' ||
            screenSize === 'small' ||
            screenSize === 'x-small'
          ))
      ">
      </app-records-list-table>
    </div>
    <div class="pagination-container" [ngClass]="{ 'in-drawer': inDrawer }">
      <nz-pagination #pagination nzShowSizeChanger nzShowQuickJumper [nzShowTotal]="rangeTemplate"
        [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzTotal]="totalRecords"
        [nzPageSizeOptions]="pageSizeOptions"
        [nzSimple]="screenSize === 'x-small' || screenSize === 'small'"
        (nzPageIndexChange)="paginationChanged(pagination)" (nzPageSizeChange)="paginationChanged(pagination)"
        [nzHideOnSinglePage]="hidePaginationOnSinglePage">
      </nz-pagination>
      <ng-template #rangeTemplate let-range="range" let-total>
        {{ range[0] }}-{{ range[1] }} of {{ total }} items
      </ng-template>
    </div>
    <div class="footer" *ngIf="inDrawer">
      <nz-space>
        <nz-space-item>
          <button nz-button nzType="primary" (click)="
            choose()
          " [disabled]="this.selectedRecords.length === 0">
            <i nz-icon nzType="check-circle" nzTheme="outline"></i>
            {{ "Choose" | locale }}
          </button>
        </nz-space-item>
        <nz-space-item>
          <button nz-button (click)="this.backButtonClicked.emit()">
            <i nz-icon nzType="close-circle" nzTheme="outline"></i>
            {{ "Cancel" | locale }}
          </button>
        </nz-space-item>
      </nz-space>
    </div>
  </div>

  <!--
<ng-container>
  <div
    class="menu-link"
    *ngFor="let menuItem of contextMenuItems; index as i"
    (click)="handleMenuItemClick($event)">
    {{ menuItem.menuText }}
    <hr *ngIf="i < contextMenuItems.length - 1" />
  </div>
</ng-container> -->

  <nz-drawer nzWrapClassName="confirmation-drawer" nzWrapClassName="drawer-size-3x" [nzVisible]="showFilterDrawer"
    [nzTitle]="'Filters' | locale" [nzFooter]="filterDrawerFooter" [nzClosable]="true"
    (nzOnClose)="showFilterDrawer = false">

    <ng-container *ngFor="let field of fields; let i = index">
      <div
        *ngIf="
          field.FieldName !== keyName &&
          field.AdditionalInformationParsed.VisibleInTableList &&
          ((fromDraft && field.AdditionalInformationParsed.FilterableInDraft) || !fromDraft)
        "
        style="margin-bottom: 16px;"
      >
        <!-- Label Row -->
        <nz-row style="margin-bottom: 4px;">
          <nz-col [nzSpan]="24" style="font-weight: bold;">
            {{ field.Label | locale }}
          </nz-col>
        </nz-row>

        <!-- Input Row -->
        <nz-row>
          <nz-col [nzSpan]="24">
            <!-- Date Range -->
            <div *ngIf="field.DataType === FieldDataType.Date">
              <nz-space nzDirection="vertical" [nzSize]="8" style="width: 100%;">
                <nz-date-picker
                  [nzDateRender]="tplRender"
                  [(ngModel)]="filters[field.PropertyName].valueFrom"
                  (ngModelChange)="filters[field.PropertyName].filterType = 2; updateFilter()"
                  [nzFormat]="global.companyConfiguration.DateFormat"
                  [nzPlaceHolder]="'From' | locale"
                  [nzSize]="'small'"
                  style="width: 100%;"
                ></nz-date-picker>

                <nz-date-picker
                  [nzDateRender]="tplRender"
                  [(ngModel)]="filters[field.PropertyName].valueTo"
                  (ngModelChange)="filters[field.PropertyName].filterType = 2; updateFilter()"
                  [nzFormat]="global.companyConfiguration.DateFormat"
                  [nzPlaceHolder]="'To' | locale"
                  [nzSize]="'small'"
                  style="width: 100%;"
                ></nz-date-picker>
              </nz-space>
            </div>

            <!-- String / Text -->
            <div *ngIf="[
                  FieldDataType.String,
                  FieldDataType.Paragraph,
                  FieldDataType.Text,
                  FieldDataType.Hidden,
                  FieldDataType.Link
                ].includes(field.DataType)">
              <input
                nz-input
                [(ngModel)]="filters[field.PropertyName].singleValue"
                (ngModelChange)="filters[field.PropertyName].filterType = 4"
                (keyup)="keyup($event)"
                [nzSize]="'small'"
                style="width: 100%;"
              />
            </div>

            <!-- Select -->
            <div *ngIf="field.DataType === FieldDataType.Select">
              <nz-select
                nzShowSearch
                (nzOpenChange)="getOptions(field)"
                nzAllowClear
                [(ngModel)]="filters[field.PropertyName].singleValue"
                (ngModelChange)="filters[field.PropertyName].filterType = 4; updateFilter()"
                [nzSize]="'small'"
                style="width: 100%;"
              >
                <ng-container *ngFor="let option of field.Options">
                  <nz-option
                    *ngIf="!isLoading"
                    [nzValue]="option.DBValue != null ? option.DBValue.toString() : option.Code.toString()"
                    [nzLabel]="
                      field.AdditionalInformationParsed.OptionsToBeTranslated
                        ? (option.Name | locale)
                        : option.Name
                    "
                  ></nz-option>
                </ng-container>
                <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                  <i nz-icon nzType="loading" class="loading-icon"></i>
                  {{ 'Loading ...' | locale }}
                </nz-option>
              </nz-select>
            </div>

            <!-- Number Range -->
            <div *ngIf="[
                  FieldDataType.Number,
                  FieldDataType.Amount,
                  FieldDataType.AmountFromDocument,
                  FieldDataType.Integer,
                  FieldDataType.Percent,
                  FieldDataType.Price,
                  FieldDataType.PriceFromDocument,
                  FieldDataType.PriceLines,
                  FieldDataType.PriceLocalCurrency,
                  FieldDataType.PriceSystemCurrency,
                  FieldDataType.Quantity
                ].includes(field.DataType)">
              <nz-space nzDirection="vertical" [nzSize]="8" style="width: 100%;">
                <nz-input-number
                  [(ngModel)]="filters[field.PropertyName].valueFrom"
                  (ngModelChange)="filters[field.PropertyName].filterType = 1"
                  (keyup)="keyup($event)"
                  [nzPlaceHolder]="'From' | locale"
                  [nzSize]="'small'"
                  style="width: 100%;"
                ></nz-input-number>

                <nz-input-number
                  [(ngModel)]="filters[field.PropertyName].valueTo"
                  (ngModelChange)="filters[field.PropertyName].filterType = 1"
                  (keyup)="keyup($event)"
                  [nzPlaceHolder]="'To' | locale"
                  [nzSize]="'small'"
                  style="width: 100%;"
                ></nz-input-number>
              </nz-space>
            </div>
          </nz-col>
        </nz-row>

        <!-- Template for Date Render -->
        <ng-template #tplRender let-current>
          <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
            {{ current.getDate() }}
          </div>
        </ng-template>
      </div>
    </ng-container>




  </nz-drawer>

  <ng-template #filterDrawerFooter>
    <nz-space>
      <nz-space-item>
        <button nz-button nzType="primary" (click)="showFilterDrawer = false;updateFilter()">
          {{ "Apply" | locale }}
        </button>
      </nz-space-item>
    </nz-space>
  </ng-template>
</div>
